<app-user-form (userAdded)="userAdded($event)"></app-user-form>
<app-user-list [allUsers]="allUsers$ | async"></app-user-list>
